<template>
  <div>
    <SimpleFieldTimeSpan
      :disabled="disabled"
      :operators="operators"
      :value.sync="mutableValue"/>
  </div>
</template>
<script>
import SimpleFieldTimeSpan from 'components/automation/conditions/default/simpleFieldTimeSpan.vue'

export default {
  name: 'timeUntilTenderCompleted',
  computed: {
    mutableValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('update:value', newValue)
      }
    }
  },
  components: {
    SimpleFieldTimeSpan
  },
  props: {
    value: {
      type: Object
    },
    disabled: {
      type: Boolean
    },
    operators: {
      type: Array
    },
  },
}
</script>
